@if (column().type === 'checkbox') {
  <div class="px-4 py-2">
    <lepi-checkbox-column [(selecteds)]="selecteds" />
  </div>
} @else {
  @let isOpenMenu =
    !column().filter?.disabled && showHeaderOption() && column().field !== 'rowNumber' && column().field !== 'checkbox';

  <button
    [cdkMenuTriggerFor]="isOpenMenu ? menu : null"
    [ngClass]="[isOpenMenu ? 'cursor-pointer' : 'cursor-default', column().style?.columnClass || '']"
    class="px-4 py-2 w-full flex text-sm font-semibold text-base-content/70">
    {{ column().name }}
  </button>
}

<ng-template #menu>
  <lepi-menu cdkMenu>
    <lepi-menu-option
      cdkMenuItem
      (click)="handleOrderBy('desc')"
      icon="ic:outline-arrow-downward"
      [active]="orderBy() === this.column().field && align() === 'desc'"
      >내림차순</lepi-menu-option
    >
    <lepi-menu-option
      cdkMenuItem
      (click)="handleOrderBy('asc')"
      icon="ic:outline-arrow-upward"
      [active]="orderBy() === this.column().field && align() === 'asc'"
      >오름차순</lepi-menu-option
    >
    <!-- <lepi-divider class="my-2" />
    <lepi-menu-option
      (click)="handleGroupBy()"
      cdkMenuItem
      icon="material-symbols:groups-2"
    >
      그룹화
    </lepi-menu-option> -->
  </lepi-menu>
</ng-template>
